import { createContext, useContext } from 'react';

export interface Identity {
  email: string;
  displayName: string;
  role: string;
  permissions: string[];
  environment: string;
}

export const IdentityContext = createContext<Identity | null>(null);
export function useIdentity(): Identity {
  const value = useContext(IdentityContext);
  if (!value) throw new Error('IdentityContext 未初始化');
  return value;
}
export function can(identity: Identity, permission: string): boolean {
  return identity.permissions.includes('*') || identity.permissions.includes(permission);
}
